import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave, fnGetTableById } from "@shared/api/restApi";
import {
  getInitFormData,
  getNoSlip,
  getTablebySql,
} from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import SnTab from "@shared/components/SnTab";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";
import SnResizeBar from "@shared/components/SnResizeBar";
import { dateToString } from "@shared/utils/DateUtils";
import { RowNode } from "ag-grid-community";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;
  [key: string]: any;
}

const SN_PRD_WRK_REG_001_TEX = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo } = global();

  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
    grid3: React.createRef(),
    grid4: React.createRef(),
    grid5: React.createRef(),
    grid6: React.createRef(),
    grid7: React.createRef(),
  });

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
    grid4: [],
    grid5: [],
    grid6: [],
    grid7: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
    grid4: [],
    grid5: [],
    grid6: [],
    grid7: [],
  });

  const LINE_GRID_KEYS = ["grid2", "grid3", "grid4", "grid5", "grid6", "grid7"];

  const ROUT_TAB_CONFIG: Record<
    string,
    { title: string; tabId: string; gridKey: string }[]
  > = {
    T10: [
      { title: "편직", tabId: "1", gridKey: "grid2" },
      { title: "염색", tabId: "2", gridKey: "grid3" },
      { title: "워싱", tabId: "5", gridKey: "grid4" },
      { title: "검사", tabId: "6", gridKey: "grid5" },
    ],

    T11: [
      { title: "편직", tabId: "1", gridKey: "grid2" },
      { title: "염색", tabId: "2", gridKey: "grid3" },
      { title: "프린트", tabId: "3", gridKey: "grid6" },
      { title: "워싱", tabId: "5", gridKey: "grid4" },
      { title: "검사", tabId: "6", gridKey: "grid5" },
    ],

    T12: [
      { title: "편직", tabId: "1", gridKey: "grid2" },
      { title: "염색", tabId: "2", gridKey: "grid3" },
      { title: "프린트", tabId: "3", gridKey: "grid6" },
      { title: "염색2", tabId: "4", gridKey: "grid7" },
      { title: "워싱", tabId: "5", gridKey: "grid4" },
      { title: "검사", tabId: "6", gridKey: "grid5" },
    ],

    T13: [{ title: "편직", tabId: "1", gridKey: "grid2" }],
  };

  const [tabConfig, setTabConfig] = useState<
    { title: string; tabId: string; gridKey: string }[]
  >([]);
  const selectedTabPage = useRef<string>("1");
  const [tab, setTab] = useState<any>("1");
  const [gridFocus, setGridFocus] = useState(false);
  const [selectedDocu, setSelectedDocu] = useState<string>("");
  const [selectedLineDocu, setSelectedLineDocu] = useState<number>(0);
  const allDataRef = useRef<any>({
    grid1: [],
    grid2: [],
    grid3: [],
    grid6: [],
    grid7: [],
    grid4: [],
    grid5: [],
  });
  const focusKeyRef = useRef<{
    no_wo?: string;
  } | null>(null);
  useImperativeHandle(ref, () => ({
    onSearch,
    onDelete,
    onInsert,
    onSave,
  }));

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
          grid3: rtn.grid.grid3,
          grid4: rtn.grid.grid4,
          grid5: rtn.grid.grid5,
          grid6: rtn.grid.grid6,
          grid7: rtn.grid.grid7,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  // 입출고현황 등에서 수불번호로 드릴다운 — 원단실적 수불번호는 원단실적번호(no_work)이고
  // mtl_qtio.no_order 에 작업지시번호가 있다. 작업지시번호·지시일로 바로 조회한다.
  useEffect(() => {
    if ((Menuprops.figure as string) !== "fg_drilldown.Search") return;
    if (columns.grid1.length === 0 || !formData) return;
    const nodeData = Menuprops.nodeData ?? {};
    const no_io = nodeData.no_io;
    if (!no_io) return;
    (async () => {
      const rows: any = await fnGetTableById({
        id: "drilldown_wrk_tex_wo",
        params: { no_io },
      });
      const wo = Array.isArray(rows) ? rows[0] : undefined;
      if (!wo?.no_wo) {
        await showDialog("alter", `수불번호 ${no_io}의 작업지시를 찾을 수 없습니다.`);
        return;
      }
      const searchData = {
        ...formData,
        cd_biz: nodeData.cd_biz ?? formData.cd_biz,
        no_wo: wo.no_wo,
        dt_from: wo.dt_wo,
        dt_to: wo.dt_wo,
        st_wo: "",
        cd_item: "",
        no_po: "",
      };
      setFormData(searchData);
      onSearch(searchData);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columns, Menuprops]);

  useEffect(() => {
    gridRefs.current["grid1"].current.selectAndFocusRow(0);
    setGridFocus(false);
  }, [gridFocus]);

  // override: 드릴다운처럼 조회조건 패널 반영(비동기) 전에 바로 조회할 때 넘긴다.
  const onSearch = async (override?: any) => {
    const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
    const lineChanges = LINE_GRID_KEYS.map((key) =>
      gridRefs.current[key]?.current?.getChange()
    );
    const hasLineChanges = lineChanges.some(
      (change) => change?.modifiedRowcount > 0
    );
    if (modifiedRowsH.modifiedRowcount > 0 || hasLineChanges) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );

      if (confirm) {
        const isSaved: any = onSave();
        if (!isSaved) return;
      }
    }

    try {
      const params = {
        id: "sn_prd_wrk_reg_001_tex_01",
        params: override ?? searchRef.current.getFormdata(),
      };

      LINE_GRID_KEYS.forEach((key) => {
        gridRefs.current[key]?.current?.resetUpdate();
      });
      setSelectedDocu("");
      const data: any = await fnGetDataSet(params);
      const allData = {
        grid1: data[0] || [],
        grid2: data[1] || [],
        grid3: data[2] || [],
        grid6: data[3] || [],
        grid7: data[4] || [],
        grid4: data[5] || [],
        grid5: data[6] || [],
      };

      // 🔥 전체 데이터 저장
      allDataRef.current = allData;

      // 🔥 최초에는 그대로 세팅 (또는 grid1만)
      setDataSources(allData);
      /*setDataSources({
        grid1: data[0],
        grid2: data[1] || [],
        grid3: data[2] || [],
        grid6: data[3] || [],
        grid7: data[4] || [],
        grid4: data[5] || [],
        grid5: data[6] || [],
      });*/
      //setGridFocus(true);
    } catch (error: any) {}
  };

  const onInsert = async () => {
    try {
      gridRefs.current["grid1"].current.stopEditing();
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedNodeH == null) {
        await showDialog("alter", "선택된 행이 없습니다.");
        return false;
      }
      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) return;
      let newRow = {};
      const currentTab = selectedTabPage.current;

      // 현재 탭 index 찾기
      const processIndex = tabConfig.findIndex((v) => v.tabId === currentTab);
      const sqlQuery = {
        sql: "select cd_op,yn_end,dc_unit,js_info ->> 'st_no_po' as st_no_po ,st_proc from prd_woproc_tex where cd_firm = :cd_firm and no_line = :no_line and no_wo = :no_wo",
        cd_firm: userInfo.cd_firm,
        no_wo: focusedNodeH.data?.no_wo,
        no_line: processIndex + 1,
      };
      const data = await getTablebySql(sqlQuery);
      data.forEach((row: any) => {
        newRow = {
          cd_op: row.cd_op,
          yn_end: row.yn_end,
          dc_unit: row.dc_unit,
          yn_autorcv: row.yn_end === "Y" ? focusedNodeH.data.yn_autorcv : "",
          st_no_po: row.st_no_po,
          st_proc: row.st_proc,
          st_rcv: "E",
          //no_po: focusedNodeH.data?.no_po,
        };
      });
      // const searchParam = searchRef.current.getFormdata();
      const today = dateToString(new Date());
      const salSohChanges =
        gridRefs.current["grid1"].current.getChange().insert;
      if (salSohChanges.length > 0) return false;
      // selectedTabPage.current === "1" 편직 공정
      if (selectedTabPage.current === "1") {
        newRow = {
          ...newRow,
          cd_firm: userInfo.cd_firm,
          cd_user_reg: userInfo.cd_user,
          no_wo: focusedNodeH.data?.no_wo,
          no_po: focusedNodeH.data?.no_po,
          no_line_wo: 1,
          cd_biz: userInfo.cd_biz,
          cd_gp: userInfo.cd_gp,
          fg_work: "S",
          cd_emp1: userInfo.cd_emp,
          cd_dept1: userInfo.cd_dept,
          dt_work: today,
          cd_item: focusedNodeH.data?.cd_item,
          qt_w: 0,
          qt_divide_w: 0,
          qt_b: 0,
          qt_divide_b: 0,
          qt: 0,
          qt_divide: 0,
        };
        gridRefs.current["grid2"].current?.addRow(newRow);
        gridRefs.current["grid2"].current.applyFilters({
          no_wo: focusedNodeH.data.no_wo,
        });
        // selectedTabPage.current === "2" 염색 공정
      } else if (selectedTabPage.current === "2") {
        let flag = true;
        for (
          let i = 0;
          i < gridRefs.current["grid2"].current.getDisplayedRowCount();
          i++
        ) {
          const node = gridRefs.current["grid2"].current.getRowNodeAtIndex(i);
          if (node?.data?.dt_rcv !== null) {
            flag = false;
            break;
          }
        }
        if (flag) {
          await showDialog("alter", "직전 공정에서 출고된 건이 없습니다.");
          return;
        }
        const wovariant_tex_op = {
          id: "wovariant_tex_op",
          params: {
            cd_firm: userInfo.cd_firm,
            no_wo: focusedNodeH.data.no_wo,
            cd_op: "T120",
          },
        };
        const search_wovariant_tex_op = await fnGetTableById(wovariant_tex_op);
        search_wovariant_tex_op.forEach((row: any, index: any) => {
          newRow = {
            ...newRow,
            cd_var2: row.cd_var2,
            cd_firm: userInfo.cd_firm,
            cd_user_reg: userInfo.cd_user,
            no_wo: focusedNodeH.data?.no_wo,
            no_po: focusedNodeH.data?.no_po,
            no_line: index + 1,
            no_line_wo: 2,
            cd_biz: userInfo.cd_biz,
            cd_gp: userInfo.cd_gp,
            fg_work: "S",
            cd_emp1: userInfo.cd_emp,
            cd_dept1: userInfo.cd_dept,
            dt_work: today,
            cd_item: focusedNodeH.data?.cd_item,
            qt_b: 0,
            qt_divide_b: 0,
            qt_w: row.qt,
            qt: row.qt,
            qt_divide_w: row.qt_divide,
            qt_divide: row.qt_divide,
          };
          gridRefs.current["grid3"].current?.addRow(newRow);
        });

        gridRefs.current["grid3"].current.applyFilters({
          no_wo: focusedNodeH.data.no_wo,
        });
        // selectedTabPage.current === "3" 프린트 공정
      } else if (selectedTabPage.current === "3") {
        let flag = true;
        for (
          let i = 0;
          i < gridRefs.current["grid3"].current.getDisplayedRowCount();
          i++
        ) {
          const node = gridRefs.current["grid3"].current.getRowNodeAtIndex(i);
          if (node?.data?.dt_rcv !== null) {
            flag = false;
            break;
          }
        }
        if (flag) {
          await showDialog("alter", "직전 공정에서 출고된 건이 없습니다.");
          return;
        }

        const wovariant_tex_op = {
          id: "wovariant_tex_op",
          params: {
            cd_firm: userInfo.cd_firm,
            no_wo: focusedNodeH.data.no_wo,
            cd_op: "T125",
          },
        };
        const search_wovariant_tex_op = await fnGetTableById(wovariant_tex_op);
        if (search_wovariant_tex_op.length > 0) {
          search_wovariant_tex_op.forEach((row: any, index: any) => {
            newRow = {
              ...newRow,
              cd_var2: row.cd_var2,
              cd_firm: userInfo.cd_firm,
              cd_user_reg: userInfo.cd_user,
              no_wo: focusedNodeH.data?.no_wo,
              no_po: focusedNodeH.data?.no_po,
              no_line: index + 1,
              no_line_wo: 3,
              cd_biz: userInfo.cd_biz,
              cd_gp: userInfo.cd_gp,
              fg_work: "S",
              cd_emp1: userInfo.cd_emp,
              cd_dept1: userInfo.cd_dept,
              dt_work: today,
              cd_item: focusedNodeH.data?.cd_item,
              qt_b: 0,
              qt_divide_b: 0,
              qt_w: row.qt,
              qt: row.qt,
              qt_divide_w: row.qt_divide,
              qt_divide: row.qt_divide,
            };
            gridRefs.current["grid6"].current?.addRow(newRow);
          });
        } else {
          let grid3Nodes: any[] = [];
          let grid6Nodes: any[] = [];
          gridRefs.current["grid3"].current.forEachFilteredNode(
            (node: RowNode) => {
              grid3Nodes.push(node);
            }
          );
          gridRefs.current["grid6"].current.forEachFilteredNode(
            (node: RowNode) => {
              grid6Nodes.push(node);
            }
          );

          const grid6Totals: Record<
            string,
            { qt_w: number; qt_divide_w: number }
          > = {};
          grid6Nodes.forEach((node: any) => {
            const cd = node.data.cd_var2;
            const qt_w = Number(node.data.qt_w) || 0;
            const qt_divide_w = Number(node.data.qt_divide_w) || 0;

            if (!grid6Totals[cd]) grid6Totals[cd] = { qt_w: 0, qt_divide_w: 0 };
            grid6Totals[cd].qt_w += qt_w;
            grid6Totals[cd].qt_divide_w += qt_divide_w;
          });

          // grid3: cd_dummy01별 qt_w 및 qt_dummy01 합계 계산
          const grid3Totals: Record<
            string,
            { qt_w: number; qt_divide_w: number; no_line: number }
          > = {};
          grid3Nodes.forEach((node: any) => {
            const cd = node.data.cd_var2;
            const qt_w = Number(node.data.qt_w) || 0;
            const qt_divide_w = Number(node.data.qt_divide_w) || 0;
            const no_line = node.data.no_line;

            if (!grid3Totals[cd])
              grid3Totals[cd] = { qt_w: 0, qt_divide_w: 0, no_line: no_line };
            grid3Totals[cd].qt_w += qt_w;
            grid3Totals[cd].qt_divide_w += qt_divide_w;
          });

          // cd_dummy01 기준으로 qt_w, qt_dummy01 비교 후 grid4에 추가
          Object.keys(grid3Totals)
            .sort()
            .forEach((cd) => {
              const qt3 = grid3Totals[cd].qt_w;
              const qt4 = grid6Totals[cd]?.qt_w || 0;
              const remain = qt3 - qt4;

              const qtDummy3 = grid3Totals[cd].qt_divide_w;
              const qtDummy4 = grid6Totals[cd]?.qt_divide_w || 0;
              const remainDummy01 = qtDummy3 - qtDummy4;

              if (remain > 0) {
                newRow = {
                  ...newRow,
                  cd_var2: cd,
                  no_line: grid3Totals[cd].no_line,
                  no_po: focusedNodeH.data?.no_po,
                  qt_w: remain,
                  qt: remain,
                  qt_divide_w: remainDummy01,
                  qt_divide: remainDummy01,
                  cd_firm: userInfo.cd_firm,
                  cd_user_reg: userInfo.cd_user,
                  no_wo: focusedNodeH.data?.no_wo,
                  no_line_wo: 3,
                  cd_biz: userInfo.cd_biz,
                  cd_gp: userInfo.cd_gp,
                  fg_work: "S",
                  cd_emp1: userInfo.cd_emp,
                  cd_dept1: userInfo.cd_dept,
                  dt_work: today,
                  cd_item: focusedNodeH.data?.cd_item,
                  qt_b: 0,
                  qt_divide_b: 0,
                };
                gridRefs.current["grid6"].current?.addRow(newRow);
              }
            });
        }
        gridRefs.current["grid6"].current.applyFilters({
          no_wo: focusedNodeH.data.no_wo,
        });
        // selectedTabPage.current === "4" 염색2 공정
      } else if (selectedTabPage.current === "4") {
        let flag = true;
        for (
          let i = 0;
          i < gridRefs.current["grid6"].current.getDisplayedRowCount();
          i++
        ) {
          const node = gridRefs.current["grid6"].current.getRowNodeAtIndex(i);
          if (node?.data?.dt_rcv !== null) {
            flag = false;
            break;
          }
        }
        if (flag) {
          await showDialog("alter", "직전 공정에서 출고된 건이 없습니다.");
          return;
        }
        const wovariant_tex_op = {
          id: "wovariant_tex_op",
          params: {
            cd_firm: userInfo.cd_firm,
            no_wo: focusedNodeH.data.no_wo,
            cd_op: "T127",
          },
        };
        const search_wovariant_tex_op = await fnGetTableById(wovariant_tex_op);
        if (search_wovariant_tex_op.length > 0) {
          search_wovariant_tex_op.forEach((row: any, index: any) => {
            newRow = {
              ...newRow,
              cd_var2: row.cd_var2,
              cd_firm: userInfo.cd_firm,
              cd_user_reg: userInfo.cd_user,
              no_wo: focusedNodeH.data?.no_wo,
              no_po: focusedNodeH.data?.no_po,
              no_line: index + 1,
              no_line_wo: 4,
              cd_biz: userInfo.cd_biz,
              cd_gp: userInfo.cd_gp,
              fg_work: "S",
              cd_emp1: userInfo.cd_emp,
              cd_dept1: userInfo.cd_dept,
              dt_work: today,
              cd_item: focusedNodeH.data?.cd_item,
              qt_b: 0,
              qt_divide_b: 0,
              qt_w: row.qt,
              qt: row.qt,
              qt_divide_w: row.qt_divide,
              qt_divide: row.qt_divide,
            };
            gridRefs.current["grid7"].current?.addRow(newRow);
          });
        } else {
          let grid6Nodes: any[] = [];
          let grid7Nodes: any[] = [];
          gridRefs.current["grid6"].current.forEachFilteredNode(
            (node: RowNode) => {
              grid6Nodes.push(node);
            }
          );
          gridRefs.current["grid7"].current.forEachFilteredNode(
            (node: RowNode) => {
              grid7Nodes.push(node);
            }
          );

          const grid7Totals: Record<
            string,
            { qt_w: number; qt_divide_w: number }
          > = {};
          grid7Nodes.forEach((node: any) => {
            const cd = node.data.cd_var2;
            const qt_w = Number(node.data.qt_w) || 0;
            const qt_divide_w = Number(node.data.qt_divide_w) || 0;

            if (!grid7Totals[cd]) grid7Totals[cd] = { qt_w: 0, qt_divide_w: 0 };
            grid7Totals[cd].qt_w += qt_w;
            grid7Totals[cd].qt_divide_w += qt_divide_w;
          });

          // grid3: cd_dummy01별 qt_w 및 qt_dummy01 합계 계산
          const grid6Totals: Record<
            string,
            { qt_w: number; qt_divide_w: number; no_line: number }
          > = {};
          grid6Nodes.forEach((node: any) => {
            const cd = node.data.cd_var2;
            const qt_w = Number(node.data.qt_w) || 0;
            const qt_divide_w = Number(node.data.qt_divide_w) || 0;
            const no_line = node.data.no_line;

            if (!grid6Totals[cd])
              grid6Totals[cd] = { qt_w: 0, qt_divide_w: 0, no_line: no_line };
            grid6Totals[cd].qt_w += qt_w;
            grid6Totals[cd].qt_divide_w += qt_divide_w;
          });

          // cd_dummy01 기준으로 qt_w, qt_dummy01 비교 후 grid4에 추가
          Object.keys(grid6Totals)
            .sort()
            .forEach((cd) => {
              const qt3 = grid6Totals[cd].qt_w;
              const qt4 = grid7Totals[cd]?.qt_w || 0;
              const remain = qt3 - qt4;

              const qtDummy3 = grid6Totals[cd].qt_divide_w;
              const qtDummy4 = grid7Totals[cd]?.qt_divide_w || 0;
              const remainDummy01 = qtDummy3 - qtDummy4;

              if (remain > 0) {
                newRow = {
                  ...newRow,
                  cd_var2: cd,
                  no_line: grid6Totals[cd].no_line,
                  no_po: focusedNodeH.data?.no_po,
                  qt_w: remain,
                  qt: remain,
                  qt_divide_w: remainDummy01,
                  qt_divide: remainDummy01,
                  cd_firm: userInfo.cd_firm,
                  cd_user_reg: userInfo.cd_user,
                  no_wo: focusedNodeH.data?.no_wo,
                  no_line_wo: 4,
                  cd_biz: userInfo.cd_biz,
                  cd_gp: userInfo.cd_gp,
                  fg_work: "S",
                  cd_emp1: userInfo.cd_emp,
                  cd_dept1: userInfo.cd_dept,
                  dt_work: today,
                  cd_item: focusedNodeH.data?.cd_item,
                  qt_b: 0,
                  qt_divide_b: 0,
                };
                gridRefs.current["grid7"].current?.addRow(newRow);
              }
            });
        }
        gridRefs.current["grid7"].current.applyFilters({
          no_wo: focusedNodeH.data.no_wo,
        });
        // selectedTabPage.current === "5" 워싱 공정
      } else if (selectedTabPage.current === "5") {
        // 워싱 공정 찾기
        const washingIndex = tabConfig.findIndex((t) => t.tabId === "5");

        if (washingIndex > 0) {
          const prevProcess = tabConfig[washingIndex - 1]; // 전공정
          const prevGridRef = gridRefs.current[prevProcess.gridKey]?.current;

          if (prevGridRef && prevGridRef.getDisplayedRowCount() > 0) {
            let flag = true;

            for (let i = 0; i < prevGridRef.getDisplayedRowCount(); i++) {
              const node = prevGridRef.getRowNodeAtIndex(i);

              if (node?.data?.dt_rcv !== null) {
                flag = false;
                break;
              }
            }

            if (flag) {
              await showDialog("alter", "직전 공정에서 출고된 건이 없습니다.");
              return;
            }
          }
        }

        const wovariant_tex_op = {
          id: "wovariant_tex_op",
          params: {
            cd_firm: userInfo.cd_firm,
            no_wo: focusedNodeH.data.no_wo,
            cd_op: "T130",
          },
        };
        const search_wovariant_tex_op = await fnGetTableById(wovariant_tex_op);
        if (search_wovariant_tex_op.length > 0) {
          search_wovariant_tex_op.forEach((row: any, index: any) => {
            newRow = {
              ...newRow,
              cd_var2: row.cd_var2,
              cd_firm: userInfo.cd_firm,
              cd_user_reg: userInfo.cd_user,
              no_wo: focusedNodeH.data?.no_wo,
              no_po: focusedNodeH.data?.no_po,
              no_line: index + 1,
              no_line_wo: 5,
              cd_biz: userInfo.cd_biz,
              cd_gp: userInfo.cd_gp,
              fg_work: "S",
              cd_emp1: userInfo.cd_emp,
              cd_dept1: userInfo.cd_dept,
              dt_work: today,
              cd_item: focusedNodeH.data?.cd_item,
              qt_b: 0,
              qt_divide_b: 0,
              qt_w: row.qt,
              qt: row.qt,
              qt_divide_w: row.qt_divide,
              qt_divide: row.qt_divide,
            };
            gridRefs.current["grid4"].current?.addRow(newRow);
          });
        } else {
          let grid763Nodes: any[] = [];
          let grid4Nodes: any[] = [];
          gridRefs.current["grid4"].current.forEachFilteredNode(
            (node: RowNode) => {
              grid4Nodes.push(node);
            }
          );
          // 워싱 공정 찾기
          const washingIndex = tabConfig.findIndex((t) => t.tabId === "5");

          if (washingIndex > 0) {
            const prevProcess = tabConfig[washingIndex - 1]; // 전공정

            const prevGridRef = gridRefs.current[prevProcess.gridKey]?.current;

            if (prevGridRef && prevGridRef.getDisplayedRowCount() > 0) {
              prevGridRef.forEachFilteredNode((node: RowNode) => {
                grid763Nodes.push(node);
              });
            }
          }

          const grid4Totals: Record<
            string,
            { qt_w: number; qt_divide_w: number }
          > = {};
          grid4Nodes.forEach((node: any) => {
            const cd = node.data.cd_var2;
            const qt_w = Number(node.data.qt_w) || 0;
            const qt_divide_w = Number(node.data.qt_divide_w) || 0;

            if (!grid4Totals[cd]) grid4Totals[cd] = { qt_w: 0, qt_divide_w: 0 };
            grid4Totals[cd].qt_w += qt_w;
            grid4Totals[cd].qt_divide_w += qt_divide_w;
          });

          // grid3: cd_dummy01별 qt_w 및 qt_dummy01 합계 계산
          const grid763Totals: Record<
            string,
            { qt_w: number; qt_divide_w: number; no_line: number }
          > = {};
          grid763Nodes.forEach((node: any) => {
            const cd = node.data.cd_var2;
            const qt_w = Number(node.data.qt_w) || 0;
            const qt_divide_w = Number(node.data.qt_divide_w) || 0;
            const no_line = node.data.no_line;

            if (!grid763Totals[cd])
              grid763Totals[cd] = { qt_w: 0, qt_divide_w: 0, no_line: no_line };
            grid763Totals[cd].qt_w += qt_w;
            grid763Totals[cd].qt_divide_w += qt_divide_w;
          });

          // cd_dummy01 기준으로 qt_w, qt_dummy01 비교 후 grid4에 추가
          Object.keys(grid763Totals)
            .sort()
            .forEach((cd) => {
              const qt3 = grid763Totals[cd].qt_w;
              const qt4 = grid4Totals[cd]?.qt_w || 0;
              const remain = qt3 - qt4;

              const qtDummy3 = grid763Totals[cd].qt_divide_w;
              const qtDummy4 = grid4Totals[cd]?.qt_divide_w || 0;
              const remainDummy01 = qtDummy3 - qtDummy4;

              if (remain > 0) {
                newRow = {
                  ...newRow,
                  cd_var2: cd,
                  no_line: grid763Totals[cd].no_line,
                  no_po: focusedNodeH.data?.no_po,
                  qt_w: remain,
                  qt: remain,
                  qt_divide_w: remainDummy01,
                  qt_divide: remainDummy01,
                  cd_firm: userInfo.cd_firm,
                  cd_user_reg: userInfo.cd_user,
                  no_wo: focusedNodeH.data?.no_wo,
                  no_line_wo: 5,
                  cd_biz: userInfo.cd_biz,
                  cd_gp: userInfo.cd_gp,
                  fg_work: "S",
                  cd_emp1: userInfo.cd_emp,
                  cd_dept1: userInfo.cd_dept,
                  dt_work: today,
                  cd_item: focusedNodeH.data?.cd_item,
                  qt_b: 0,
                  qt_divide_b: 0,
                };
                gridRefs.current["grid4"].current?.addRow(newRow);
              }
            });
        }
        gridRefs.current["grid4"].current.applyFilters({
          no_wo: focusedNodeH.data.no_wo,
        });
      }
      // selectedTabPage.current === "6" 검사 공정
      else if (selectedTabPage.current === "6") {
        let flag = true;
        for (
          let i = 0;
          i < gridRefs.current["grid4"].current.getDisplayedRowCount();
          i++
        ) {
          const node = gridRefs.current["grid4"].current.getRowNodeAtIndex(i);
          if (node?.data?.dt_rcv !== null) {
            flag = false;
            break;
          }
        }
        if (flag) {
          await showDialog("alter", "직전 공정에서 출고된 건이 없습니다.");
          return;
        }
        const wovariant_tex_op = {
          id: "wovariant_tex_op",
          params: {
            cd_firm: userInfo.cd_firm,
            no_wo: focusedNodeH.data.no_wo,
            cd_op: "T140",
          },
        };
        const search_wovariant_tex_op = await fnGetTableById(wovariant_tex_op);
        if (search_wovariant_tex_op.length > 0) {
          search_wovariant_tex_op.forEach((row: any, index: any) => {
            newRow = {
              ...newRow,
              cd_var2: row.cd_var2,
              cd_firm: userInfo.cd_firm,
              cd_user_reg: userInfo.cd_user,
              no_wo: focusedNodeH.data?.no_wo,
              no_po: focusedNodeH.data?.no_po,
              no_line: index + 1,
              no_line_wo: 6,
              cd_biz: userInfo.cd_biz,
              cd_gp: userInfo.cd_gp,
              fg_work: "S",
              cd_emp1: userInfo.cd_emp,
              cd_dept1: userInfo.cd_dept,
              dt_work: today,
              cd_item: focusedNodeH.data?.cd_item,
              qt_b: 0,
              qt_divide_b: 0,
              qt_w: row.qt,
              qt: row.qt,
              qt_divide_w: row.qt_divide,
              qt_divide: row.qt_divide,
            };
            gridRefs.current["grid5"].current?.addRow(newRow);
          });
        } else {
          let grid4Nodes: any[] = [];
          let grid5Nodes: any[] = [];
          gridRefs.current["grid4"].current.forEachFilteredNode(
            (node: RowNode) => {
              grid4Nodes.push(node);
              newRow = {
                ...newRow,
                no_line: node.data.no_line,
              };
            }
          );
          gridRefs.current["grid5"].current.forEachFilteredNode(
            (node: RowNode) => {
              grid5Nodes.push(node);
            }
          );

          const grid5Totals: Record<
            string,
            { qt_w: number; qt_divide_w: number }
          > = {};
          grid5Nodes.forEach((node: any) => {
            const cd = node.data.cd_var2;
            const qt_w = Number(node.data.qt_w) || 0;
            const qt_divide_w = Number(node.data.qt_divide_w) || 0;
            if (!grid5Totals[cd]) grid5Totals[cd] = { qt_w: 0, qt_divide_w: 0 };
            grid5Totals[cd].qt_w += qt_w;
            grid5Totals[cd].qt_divide_w += qt_divide_w;
          });

          // grid3: cd_dummy01별 qt_w 및 qt_dummy01 합계 계산
          const grid4Totals: Record<
            string,
            { qt_w: number; qt_divide_w: number; no_line: number }
          > = {};
          grid4Nodes.forEach((node: any) => {
            const cd = node.data.cd_var2;
            const qt_w = Number(node.data.qt_w) || 0;
            const qt_divide_w = Number(node.data.qt_divide_w) || 0;
            const no_line = node.data.no_line;

            if (!grid4Totals[cd])
              grid4Totals[cd] = { qt_w: 0, qt_divide_w: 0, no_line: no_line };
            grid4Totals[cd].qt_w += qt_w;
            grid4Totals[cd].qt_divide_w += qt_divide_w;
          });

          // cd_dummy01 기준으로 qt_w, qt_dummy01 비교 후 grid4에 추가
          Object.keys(grid4Totals).forEach((cd) => {
            const qt4 = grid4Totals[cd].qt_w;
            const qt5 = grid5Totals[cd]?.qt_w || 0;
            const remain = Math.floor(
              qt4 / focusedNodeH.data?.qt_dummy01 - qt5
            );

            const qtDummy4 = grid4Totals[cd].qt_divide_w;
            const qtDummy5 = grid5Totals[cd]?.qt_divide_w || 0;
            const remainDummy01 = qtDummy4 - qtDummy5;

            if (remain > 0) {
              newRow = {
                ...newRow,
                cd_var2: cd,
                no_line: grid4Totals[cd].no_line,
                no_po: focusedNodeH.data?.no_po,
                qt_w: remain,
                qt: remain,
                qt_divide_w: remainDummy01,
                qt_divide: remainDummy01,
                cd_firm: userInfo.cd_firm,
                cd_user_reg: userInfo.cd_user,
                no_wo: focusedNodeH.data?.no_wo,
                no_line_wo: 6,
                cd_biz: userInfo.cd_biz,
                cd_gp: userInfo.cd_gp,
                fg_work: "S",
                cd_emp1: userInfo.cd_emp,
                cd_dept1: userInfo.cd_dept,
                dt_work: today,
                cd_item: focusedNodeH.data?.cd_item,
                qt_b: 0,
                qt_divide_b: 0,
              };
              gridRefs.current["grid5"].current?.addRow(newRow);
            }
          });
        }

        gridRefs.current["grid5"].current.applyFilters({
          no_wo: focusedNodeH.data.no_wo,
        });
      }
    } catch (error: any) {}
  };

  const onDelete = async () => {
    tabConfig.forEach((tab) => {
      const gridKey = tab.gridKey as keyof typeof gridRefs.current;
      const gridRef = gridRefs.current[gridKey];
      if (gridRef.current?.getDisplayedRowCount() < 0) return;
    });
    const currentTab = tabConfig.find(
      (tab) => tab.tabId === selectedTabPage.current
    );
    const gridRef = currentTab
      ? gridRefs.current[currentTab.gridKey]?.current
      : null;

    if (!gridRef || gridRef.getDisplayedRowCount() <= 0) return;
    if (selectedTabPage.current === "1") {
      const gridSelectedRow =
        gridRefs.current["grid2"].current.getSelectedRows();
      if (gridSelectedRow[0]?.st_proc === "C") {
        await showDialog(
          "warning",
          "실적 마감의 경우 행삭제 하실 수 없습니다."
        );
        return;
      }
      gridRefs.current["grid2"].current?.deleteSelectedRows();
    } else if (selectedTabPage.current === "2") {
      const gridSelectedRow =
        gridRefs.current["grid3"].current.getSelectedRows();
      if (gridSelectedRow[0]?.st_proc === "C") {
        await showDialog(
          "warning",
          "실적 마감의 경우 행삭제 하실 수 없습니다."
        );
        return;
      }
      gridRefs.current["grid3"].current?.deleteSelectedRows();
    } else if (selectedTabPage.current === "3") {
      const gridSelectedRow =
        gridRefs.current["grid6"].current.getSelectedRows();
      if (gridSelectedRow[0]?.st_proc === "C") {
        await showDialog(
          "warning",
          "실적 마감의 경우 행삭제 하실 수 없습니다."
        );
        return;
      }
      gridRefs.current["grid6"].current?.deleteSelectedRows();
    } else if (selectedTabPage.current === "4") {
      const gridSelectedRow =
        gridRefs.current["grid7"].current.getSelectedRows();
      if (gridSelectedRow[0]?.st_proc === "C") {
        await showDialog(
          "warning",
          "실적 마감의 경우 행삭제 하실 수 없습니다."
        );
        return;
      }
      gridRefs.current["grid7"].current?.deleteSelectedRows();
    } else if (selectedTabPage.current === "5") {
      const gridSelectedRow =
        gridRefs.current["grid4"].current.getSelectedRows();
      if (gridSelectedRow[0]?.st_proc === "C") {
        await showDialog(
          "warning",
          "실적 마감의 경우 행삭제 하실 수 없습니다."
        );
        return;
      }
      gridRefs.current["grid4"].current?.deleteSelectedRows();
    } else if (selectedTabPage.current === "6") {
      const gridSelectedRow =
        gridRefs.current["grid5"].current.getSelectedRows();
      if (gridSelectedRow[0]?.st_proc === "C") {
        await showDialog(
          "warning",
          "실적 마감의 경우 행삭제 하실 수 없습니다."
        );
        return;
      }
      gridRefs.current["grid5"].current?.deleteSelectedRows();
    }
  };

  const onCellValueChangedL = async (event: CellValueChangedEvent) => {
    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    if (colId === "qt_w" || colId === "qt_b") {
      rowNode.setDataValue("qt", rowData.qt_w + rowData.qt_b);
    } else if (colId === "qt_divide_w" || colId === "qt_divide_b") {
      rowNode.setDataValue(
        "qt_divide",
        rowData.qt_divide_w + rowData.qt_divide_b
      );
    }
  };
  const onSave = async () => {
    try {
      for (const tab of tabConfig) {
        const gridKey = tab.gridKey as keyof typeof gridRefs.current;
        const gridRef = gridRefs.current[gridKey];

        gridRef?.current?.stopEditing();

        const check = gridRef?.current?.requiredValuesCheck();
        if (!check) return false;
        // 🔥 추가 조건 검사
        const grid = gridRef?.current;

        if (grid) {
          let flag = true;
          for (let i = 0; i < grid.getDisplayedRowCount(); i++) {
            const node = grid.getRowNodeAtIndex(i);
            const row = node?.data;
            if (
              (row.dt_rcv === null || row.dt_rcv === "") &&
              row.st_rcv === "D"
            ) {
              await showDialog(
                "alter",
                "출고된 실적은 출고일자를 입력해주세요."
              );
              flag = false;
              break;
            }
            if (
              row &&
              Number(row.qt) === 0 &&
              (row.dc_rmk === null ||
                row.dc_rmk === "" ||
                row.dc_rmk === undefined)
            ) {
              await showDialog("alter", "실적수량이 0입니다.");
              flag = false;
              break;
            }
          }
          if (!flag) return;
        }
      }

      const gridChanges = tabConfig.map((tab) => {
        const gridRef = gridRefs.current[tab.gridKey];
        return gridRef?.current?.getChange() ?? null;
      });

      const hasChange = gridChanges.some((g) => g && g.modifiedRowcount > 0);

      if (!hasChange) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return false;
      }

      const noproblem = await qtCheck();

      if (!noproblem) return;
      const cd_module: any = Menuprops.cd_module;
      const cd_menu: any = Menuprops.cd_menu;
      const today = dateToString(new Date());
      let generatedNoWork: string | null = null;
      for (const g of gridChanges) {
        if (g.modifiedRowcount === 0) continue;
        // 🔥 update 검사
        const updateRows = g.update ?? [];

        for (const row of updateRows) {
          if (row.st_proc === "C") {
            await showDialog("alter", "매입 마감 건입니다.");
            return;
          }
        }

        const insertRows = g.insert ?? [];
        let no_line = 1;

        for (let row of insertRows) {
          if (!row.no_work) {
            if (!generatedNoWork) {
              generatedNoWork = await getNoSlip(
                cd_module,
                1,
                "WRK",
                today,
                cd_menu
              );
            }

            row.no_work = generatedNoWork;
          }

          row.no_line = no_line++;
        }
      }
      // insert/update/delete를 전부 합치기
      const merged = {
        insert: [] as any[],
        update: [] as any[],
        delete: [] as any[],
        modifiedRowcount: 0,
      };

      const woprocTexUpdate: any[] = [];
      const woTexUpdate: any[] = [];

      const selectedRows = gridRefs.current["grid1"].current.focusedRowNode();
      let flag = false;
      const totalProcCount = tabConfig.reduce((sum, t) => {
        const ref = gridRefs.current[t.gridKey]?.current;
        ref.forEachNode((node: any) => {
          if ("C" === node.data.st_proc) {
            flag = true;
            return 0;
          }
        });
        return sum + (ref?.getDisplayedRowCount?.() ?? 0);
      }, 0);

      let globalStWo = totalProcCount === 0 ? "R" : "S";
      if (flag) globalStWo = "C";
      tabConfig.forEach((tab, i) => {
        const g = gridChanges[i];
        if (!g) return;

        merged.insert.push(...(g.insert ?? []));
        merged.update.push(...(g.update ?? []));
        merged.delete.push(...(g.delete ?? []));
        merged.modifiedRowcount += g.modifiedRowcount ?? 0;

        const gridRef = gridRefs.current[tab.gridKey]?.current;

        const hasYnEndY = [
          ...(g.insert ?? []),
          ...(g.update ?? []),
          ...(g.delete ?? []),
        ].some((r) => r.yn_end === "Y");
        const noLine = tabConfig.findIndex((t) => t.tabId === tab.tabId) + 1;
        if (g.modifiedRowcount > 0 && gridRef) {
          const footerQt = gridRef.getFooterData().qt;
          const st_wo = footerQt === 0 ? "R" : "S";
          const cnt = gridRef.getDisplayedRowCount();

          if (cnt > 0) {
            if (hasYnEndY) {
              woTexUpdate.push({
                cd_firm: userInfo.cd_firm,
                no_wo: selectedRows.data.no_wo,
                qt_work: footerQt,
                st_wo: "S",
              });
            } else {
              woTexUpdate.push({
                cd_firm: userInfo.cd_firm,
                no_wo: selectedRows.data.no_wo,
                st_wo: "S",
              });
            }
          } else {
            if (hasYnEndY) {
              woTexUpdate.push({
                cd_firm: userInfo.cd_firm,
                no_wo: selectedRows.data.no_wo,
                qt_work: footerQt,
                st_wo: "S",
              });
            }
            woTexUpdate.push({
              cd_firm: userInfo.cd_firm,
              no_wo: selectedRows.data.no_wo,
              st_wo: "R",
            });
          }

          woprocTexUpdate.push({
            cd_firm: userInfo.cd_firm,
            no_wo: selectedRows.data.no_wo,
            no_line: noLine,
            qt_work: footerQt,
            st_proc: st_wo,
          });
        }
      });
      const merged2 = {
        update: woprocTexUpdate,
        modifiedRowcount: woprocTexUpdate.length,
      };
      const merged3 = {
        update: woTexUpdate,
        modifiedRowcount: woTexUpdate.length,
      };

      let SaveData: any = {
        prd_workproc_tex: merged, // 기존
        prd_woproc_tex: merged2, // 기존
        prd_wo_tex: merged3, // 기존
      };
      const grid5Insert =
        selectedRows.data.cd_rout === "T13"
          ? gridRefs.current["grid2"].current.getChange().insert
          : gridRefs.current["grid5"].current.getChange().insert;
      if (grid5Insert.length > 0) {
        const mtlQtiohInserts: any[] = [];
        const mtlQtioInserts: any[] = [];
        const sqlQuery = {
          sql: "select w.cd_io_rcv, i.fg_slip, i.tp_slip, i.fg_io, i.fg_money from mas_wotype w inner join mas_iotype i ON w.cd_io_rcv = i.cd_io AND w.cd_firm = i.cd_firm WHERE w.cd_firm = :cd_firm AND w.cd_wo   = :cd_wo",
          cd_firm: userInfo.cd_firm,
          cd_wo: selectedRows.data?.cd_wo,
        };
        const data = await getTablebySql(sqlQuery);
        let qt_w = 0,
          qt_b = 0;
        const reqNo = generatedNoWork?.concat("_R");
        const reqNoB = generatedNoWork?.concat("_B");
        const mtlQtioTexInserts: any[] = [];
        for (let row of grid5Insert) {
          if (grid5Insert[0].dt_rcv && row.qt_w > 0) {
            qt_w += row.qt_w;
            mtlQtioTexInserts.push({
              cd_firm: userInfo.cd_firm,
              cd_wh: selectedRows.data.cd_wh_rcv,
              no_io: reqNo,
              no_line: 1,
              fg_slip: "1",
              no_line_var: row.no_line,
              tp_slip: "3",
              fg_io: "1",
              cd_io: "330",
              cd_item: selectedRows.data.cd_item,
              cd_var2: row.cd_var2,
              qt: row.qt_w,
              qt_w: row.qt_w,
              qt_divide: row.qt_divide_w,
              qt_divide_w: row.qt_divide_w,
              dt_rcv: grid5Insert[0].dt_rcv ?? null,
              no_po: row.no_po,
              dt_io: grid5Insert[0].dt_rcv ?? today,
              no_style: null,
              cd_dummy01: null,
              no_order: selectedRows.data.no_wo,
              no_line_order: 6,
            });
          }
          if (row.qt_b > 0) {
            qt_b += row.qt_b;
            mtlQtioTexInserts.push({
              cd_firm: userInfo.cd_firm,
              cd_wh: selectedRows.data.cd_wh_rcv,
              no_io: reqNoB,
              no_line: 1,
              fg_slip: "1",
              no_line_var: row.no_line,
              tp_slip: "3",
              fg_io: "1",
              cd_io: "330",
              cd_item: selectedRows.data.cd_item,
              cd_var2: row.cd_var2,
              qt: row.qt_b,
              qt_b: row.qt_b,
              qt_divide_b: row.qt_divide_b,
              qt_divide: row.qt_divide_b,
              dt_rcv: grid5Insert[0].dt_rcv ?? null,
              no_po: row.no_po,
              dt_io: grid5Insert[0].dt_rcv ?? today,
              no_style: null,
              cd_dummy01: null,
              no_order: selectedRows.data.no_wo,
              no_line_order: 6,
            });
          }
        }
        if (grid5Insert[0].dt_rcv && qt_w > 0) {
          mtlQtiohInserts.push({
            cd_firm: selectedRows.data.cd_firm,
            no_io: reqNo,
            cd_biz: userInfo.cd_biz,
            cd_wh: selectedRows.data.cd_wh_rcv,
            dt_io: grid5Insert[0].dt_rcv ?? today,
            cd_io: data[0].cd_io_rcv,
            fg_slip: data[0].fg_slip,
            tp_slip: data[0].tp_slip,
            fg_io: data[0].fg_io,
            fg_money: data[0].fg_money,
            fg_trns: null,
            yn_autoprocess: "Y",
            cd_dept: userInfo.cd_dept,
            cd_emp: userInfo.cd_emp,
            cd_gp: userInfo.cd_gp,
            yn_autorcv: "Y",
            fg_map: "1",
            yn_send: "N",
            reg_dt: new Date(),
            cd_cust: selectedRows.data.cd_cust,
          });

          mtlQtioInserts.push({
            cd_firm: selectedRows.data.cd_firm,
            no_io: reqNo,
            no_line: 1,
            cd_biz: userInfo.cd_biz,
            cd_wh: selectedRows.data.cd_wh_rcv,
            cd_io: data[0].cd_io_rcv,
            fg_slip: data[0].fg_slip,
            tp_slip: data[0].tp_slip,
            fg_io: data[0].fg_io,
            fg_money: data[0].fg_money,
            cd_item: selectedRows.data.cd_item,
            qt_good: qt_w,
            qt: qt_w,
            no_order: selectedRows.data.no_wo,
            no_line_order: 6,
            no_req: generatedNoWork,
            dt_io: grid5Insert[0].dt_rcv ?? today,
            fg_map: "1",
            fg_req: "100",
            yn_req: "N",
            yn_insp_report: "N",
            yn_cls_crm: "N",
            no_lot: null,
            dc_dummy01: null,
            cd_dummy02: null,
          });
        }
        if (qt_b > 0) {
          mtlQtiohInserts.push({
            cd_firm: selectedRows.data.cd_firm,
            no_io: reqNoB,
            cd_biz: userInfo.cd_biz,
            cd_wh: selectedRows.data.cd_wh_rcv,
            dt_io: grid5Insert[0].dt_rcv ?? today,
            cd_io: data[0].cd_io_rcv,
            fg_slip: data[0].fg_slip,
            tp_slip: data[0].tp_slip,
            fg_io: data[0].fg_io,
            fg_money: data[0].fg_money,
            fg_trns: null,
            yn_autoprocess: "Y",
            cd_dept: userInfo.cd_dept,
            cd_emp: userInfo.cd_emp,
            cd_gp: userInfo.cd_gp,
            yn_autorcv: "Y",
            fg_map: "1",
            yn_send: "N",
            reg_dt: new Date(),
            cd_cust: selectedRows.data.cd_cust,
          });

          mtlQtioInserts.push({
            cd_firm: selectedRows.data.cd_firm,
            no_io: reqNoB,
            no_line: 1,
            cd_biz: userInfo.cd_biz,
            cd_wh: selectedRows.data.cd_wh_rcv,
            cd_io: data[0].cd_io_rcv,
            fg_slip: data[0].fg_slip,
            tp_slip: data[0].tp_slip,
            fg_io: data[0].fg_io,
            fg_money: data[0].fg_money,
            cd_item: selectedRows.data.cd_item,
            qt_bad: qt_b,
            qt: qt_b,
            no_order: selectedRows.data.no_wo,
            no_line_order: 6,
            no_req: generatedNoWork,
            dt_io: grid5Insert[0].dt_rcv ?? today,
            fg_map: "1",
            fg_req: "100",
            yn_req: "N",
            yn_insp_report: "N",
            yn_cls_crm: "N",
            no_lot: null,
            dc_dummy01: null,
            cd_dummy02: null,
          });
        }

        const mtlQtiohChanges = {
          insert: mtlQtiohInserts,
          update: [],
          delete: [],
          modifiedRowcount: mtlQtiohInserts.length,
        };
        const mtlQtioChanges = {
          insert: mtlQtioInserts,
          update: [],
          delete: [],
          modifiedRowcount: mtlQtioInserts.length,
        };
        const mtlQtioTexChanges = {
          insert: mtlQtioTexInserts,
          update: [],
          delete: [],
          modifiedRowcount: mtlQtioTexInserts.length,
        };
        SaveData.mtl_qtioh = mtlQtiohChanges;
        SaveData.mtl_qtio = mtlQtioChanges;
        SaveData.mtl_qtio_tex = mtlQtioTexChanges;
      } else if (merged.update.length > 0 && merged.update[0].yn_end === "Y") {
        const mtlQtiohInserts: any[] = [];
        const mtlQtiohUpdates: any[] = [];
        const mtlQtioInserts: any[] = [];
        const mtlQtioUpdates: any[] = [];
        const mtlQtioTexInserts: any[] = [];
        const mtlQtioTexUpdates: any[] = [];

        const dtRcvMap = new Map<string, string>();

        // -----------------------------
        // 🔥 0️⃣ 기본값 조회 (필수)
        // -----------------------------
        const baseInfo = await getTablebySql({
          sql: `
      select w.cd_io_rcv, i.fg_slip, i.tp_slip, i.fg_io, i.fg_money
      from mas_wotype w
      inner join mas_iotype i 
        on w.cd_io_rcv = i.cd_io 
       and w.cd_firm = i.cd_firm
      where w.cd_firm = :cd_firm
        and w.cd_wo   = :cd_wo
    `,
          cd_firm: userInfo.cd_firm,
          cd_wo: selectedRows.data?.cd_wo,
        });

        if (!baseInfo || baseInfo.length === 0) {
          throw new Error("입출고 유형 정보를 찾을 수 없습니다.");
        }

        const base = baseInfo[0];

        // -----------------------------
        // 1️⃣ 기존 TEX 조회
        // -----------------------------

        const existTexList = await getTablebySql({
          sql: `
      select no_io, no_line_var
      from mtl_qtio_tex
      where cd_firm = :cd_firm
      and no_order = :no_wo
    `,
          cd_firm: userInfo.cd_firm,
          no_wo: selectedRows.data.no_wo,
        });

        const texExistSet = new Set(
          existTexList.map((r: any) => `${r.no_io}_${r.no_line_var}`)
        );

        // -----------------------------
        // 3️⃣ QTIO / QTIOH (🔥 grid 기준 재계산)
        // -----------------------------

        // 🔥 핵심: merged.update ❌ → grid 전체 기준으로 다시 계산
        const ioGroup = new Map<string, { qt_good: number; qt_bad: number }>();
        const gridkey =
          selectedRows.data.cd_rout === "T13"
            ? gridRefs.current["grid2"].current
            : gridRefs.current["grid5"].current;
        gridkey.forEachFilteredNode((node: any) => {
          const row = node.data;

          const noIoR = row.no_work + "_R";
          const noIoB = row.no_work + "_B";

          const hasRcv = !!row.dt_rcv;
          const qtW = Number(row.qt_w ?? 0);
          const qtB = Number(row.qt_b ?? 0);

          // 🔵 양품
          if (hasRcv) {
            const prev = ioGroup.get(noIoR) ?? { qt_good: 0, qt_bad: 0 };

            ioGroup.set(noIoR, {
              qt_good: prev.qt_good + qtW,
              qt_bad: prev.qt_bad,
            });
          }

          // 🔴 불량
          {
            const prev = ioGroup.get(noIoB) ?? { qt_good: 0, qt_bad: 0 };

            ioGroup.set(noIoB, {
              qt_good: prev.qt_good,
              qt_bad: prev.qt_bad + qtB,
            });
          }

          // dt_rcv도 같이 유지
          if (hasRcv && !dtRcvMap.has(noIoR)) {
            dtRcvMap.set(noIoR, row.dt_rcv);
          }
          if (!dtRcvMap.has(noIoB)) {
            dtRcvMap.set(noIoB, row.dt_rcv);
          }
        });
        // -----------------------------
        // 2️⃣ TEX 처리 (🔥 이거 빠져있던 핵심)
        // -----------------------------
        for (const row of merged.update) {
          const noIoR = row.no_work + "_R";
          const noIoB = row.no_work + "_B";

          const hasRcv = !!row.dt_rcv;
          const qtW = Number(row.qt_w ?? 0);
          const qtB = Number(row.qt_b ?? 0);

          // dt_rcv 세팅 (QTIO에서도 쓰니까 여기서 미리)
          if (hasRcv && !dtRcvMap.has(noIoR)) {
            dtRcvMap.set(noIoR, row.dt_rcv);
          }
          if (!dtRcvMap.has(noIoB)) {
            dtRcvMap.set(noIoB, row.dt_rcv);
          }

          // 🔵 양품 TEX
          if (
            hasRcv &&
            (qtW > 0 || texExistSet.has(`${noIoR}_${row.no_line}`))
          ) {
            const key = `${noIoR}_${row.no_line}`;
            const isExist = texExistSet.has(key);

            const texData = {
              cd_firm: row.cd_firm,
              no_io: noIoR,
              fg_slip: base.fg_slip,
              no_line: 1,
              no_line_var: row.no_line,
              qt: qtW,
              qt_w: qtW,
              qt_divide: row.qt_divide_w,
              qt_divide_w: row.qt_divide_w,
              dt_rcv: row.dt_rcv,
              no_po: row.no_po,
              dt_io: row.dt_rcv,
              cd_wh: selectedRows.data.cd_wh_rcv,
              tp_slip: "3",
              fg_io: "1",
              cd_io: "330",
              cd_item: selectedRows.data.cd_item,
              cd_var2: row.cd_var2,
              no_order: selectedRows.data.no_wo,
              no_line_order: 6,
            };

            if (isExist) mtlQtioTexUpdates.push(texData);
            else mtlQtioTexInserts.push(texData);
          }

          // 🔴 불량 TEX
          if (qtB > 0 || texExistSet.has(`${noIoB}_${row.no_line}`)) {
            const key = `${noIoB}_${row.no_line}`;
            const isExist = texExistSet.has(key);

            const texData = {
              cd_firm: row.cd_firm,
              no_io: noIoB,
              fg_slip: base.fg_slip,
              no_line: 1,
              no_line_var: row.no_line,
              qt: qtB,
              qt_b: qtB,
              qt_divide: row.qt_divide_b,
              qt_divide_b: row.qt_divide_b,
              dt_rcv: row.dt_rcv ?? null,
              no_po: row.no_po,
              dt_io: row.dt_rcv ?? today,
              cd_wh: selectedRows.data.cd_wh_rcv,
              tp_slip: "3",
              fg_io: "1",
              cd_io: "330",
              cd_item: selectedRows.data.cd_item,
              cd_var2: row.cd_var2,
              no_order: selectedRows.data.no_wo,
              no_line_order: 6,
            };

            if (isExist) mtlQtioTexUpdates.push(texData);
            else mtlQtioTexInserts.push(texData);
          }
        }
        // -----------------------------
        // 3️⃣ QTIO / QTIOH (재계산)
        // -----------------------------
        for (const [no_io, sum] of ioGroup) {
          const existHeader = await getTablebySql({
            sql: `
        select 1
        from mtl_qtioh
        where cd_firm = :cd_firm
        and no_io = :no_io
      `,
            cd_firm: userInfo.cd_firm,
            no_io,
          });

          const totalQt = (sum.qt_good ?? 0) + (sum.qt_bad ?? 0);

          if (existHeader.length === 0) {
            // 🔥 HEADER INSERT (기본값 전부 포함)
            mtlQtiohInserts.push({
              cd_firm: selectedRows.data.cd_firm,
              no_io,
              cd_biz: userInfo.cd_biz,
              cd_wh: selectedRows.data.cd_wh_rcv,
              dt_io: dtRcvMap.get(no_io) ?? today,
              cd_io: base.cd_io_rcv,
              fg_slip: base.fg_slip,
              tp_slip: base.tp_slip,
              fg_io: base.fg_io,
              fg_money: base.fg_money,
              fg_trns: null,
              yn_autoprocess: "Y",
              cd_dept: userInfo.cd_dept,
              cd_emp: userInfo.cd_emp,
              cd_gp: userInfo.cd_gp,
              yn_autorcv: "Y",
              fg_map: "1",
              yn_send: "N",
              reg_dt: new Date(),
              cd_cust: selectedRows.data.cd_cust,
            });

            // 🔥 QTIO INSERT (fg_slip 필수)
            mtlQtioInserts.push({
              cd_firm: selectedRows.data.cd_firm,
              cd_biz: userInfo.cd_biz,
              cd_wh: selectedRows.data.cd_wh_rcv,
              cd_io: base.cd_io_rcv,
              cd_item: selectedRows.data.cd_item,
              no_io,
              fg_slip: base.fg_slip, // 🔥 필수
              no_line: 1,
              qt: totalQt,
              qt_good: sum.qt_good,
              qt_bad: sum.qt_bad,
              dt_io: dtRcvMap.get(no_io) ?? today,
              tp_slip: base.tp_slip,
              fg_io: base.fg_io,
              fg_money: base.fg_money,
              no_order: selectedRows.data.no_wo,
              no_line_order: 6,
              no_req: generatedNoWork,
              fg_map: "1",
              fg_req: "100",
              yn_req: "N",
              yn_insp_report: "N",
              yn_cls_crm: "N",
              no_lot: null,
              dc_dummy01: null,
              cd_dummy02: null,
            });
          } else {
            mtlQtiohUpdates.push({
              cd_firm: selectedRows.data.cd_firm,
              no_io,
              dt_io: dtRcvMap.get(no_io),
            });

            // 🔥 QTIO UPDATE (재계산 덮어쓰기)
            mtlQtioUpdates.push({
              cd_firm: selectedRows.data.cd_firm,
              no_io,
              fg_slip: base.fg_slip,
              cd_biz: userInfo.cd_biz,
              cd_wh: selectedRows.data.cd_wh_rcv,
              cd_io: "330",
              no_line: 1,
              qt: totalQt,
              qt_good: sum.qt_good,
              qt_bad: sum.qt_bad,
              dt_io: dtRcvMap.get(no_io),
            });
          }
        }

        // -----------------------------
        // 4️⃣ SaveData
        // -----------------------------
        SaveData.mtl_qtioh = {
          insert: mtlQtiohInserts,
          update: mtlQtiohUpdates,
          delete: [],
          modifiedRowcount: mtlQtiohInserts.length + mtlQtiohUpdates.length,
        };

        SaveData.mtl_qtio = {
          insert: mtlQtioInserts,
          update: mtlQtioUpdates,
          delete: [],
          modifiedRowcount: mtlQtioInserts.length + mtlQtioUpdates.length,
        };

        SaveData.mtl_qtio_tex = {
          insert: mtlQtioTexInserts,
          update: mtlQtioTexUpdates,
          delete: [],
          modifiedRowcount: mtlQtioTexInserts.length + mtlQtioTexUpdates.length,
        };
      } else if (merged.delete.length > 0) {
        /****************************************************************
         * 1. DELETE 대상 no_io 수집
         ****************************************************************/
        const targetNoIoSet = new Set<string>();

        for (const row of merged.delete ?? []) {
          targetNoIoSet.add(row.no_work + "_R");
          targetNoIoSet.add(row.no_work + "_B");
        }

        /****************************************************************
         * 2. grid5 기준 현재 남아있는 qt 합산
         ****************************************************************/
        const qtioSumMapR = new Map<string, number>();
        const qtioSumMapB = new Map<string, number>();
        const gridkey =
          selectedRows.data.cd_rout === "T13"
            ? gridRefs.current["grid2"].current
            : gridRefs.current["grid5"].current;
        gridkey.forEachFilteredNode((node: any) => {
          const row = node.data;
          const noIoR = row.no_work + "_R";
          const noIoB = row.no_work + "_B";

          if (targetNoIoSet.has(noIoR)) {
            const prev = qtioSumMapR.get(noIoR) ?? 0;
            qtioSumMapR.set(noIoR, prev + Number(row.qt_w ?? 0));
          }

          if (targetNoIoSet.has(noIoB)) {
            const prev = qtioSumMapB.get(noIoB) ?? 0;
            qtioSumMapB.set(noIoB, prev + Number(row.qt_b ?? 0));
          }
        });

        /****************************************************************
         * 3. mtl_qtio UPDATE (아직 row가 남아있는 no_io)
         ****************************************************************/
        const mtlQtioUpdates: any[] = [];

        for (const [no_io, sumQt] of qtioSumMapR.entries()) {
          if (sumQt > 0) {
            mtlQtioUpdates.push({
              cd_firm: selectedRows.data.cd_firm,
              no_io,
              fg_slip: 1,
              no_line: 1,
              qt: sumQt,
              qt_good: sumQt,
            });
          }
        }
        for (const [no_io, sumQt] of qtioSumMapB.entries()) {
          if (sumQt > 0) {
            mtlQtioUpdates.push({
              cd_firm: selectedRows.data.cd_firm,
              no_io,
              fg_slip: 1,
              no_line: 1,
              qt: sumQt,
              qt_bad: sumQt,
            });
          }
        }

        /****************************************************************
         * 4. mtl_qtio_tex ROW 단위 DELETE (PK 완성)
         ****************************************************************/
        const mtlQtioTexRowDeletes: any[] = [];

        for (const row of merged.delete ?? []) {
          mtlQtioTexRowDeletes.push({
            cd_firm: row.cd_firm,
            no_io: row.no_work + "_R",
            fg_slip: 1,
            no_line: 1,
            no_line_var: row.no_line,
          });
          mtlQtioTexRowDeletes.push({
            cd_firm: row.cd_firm,
            no_io: row.no_work + "_B",
            fg_slip: 1,
            no_line: 1,
            no_line_var: row.no_line,
          });
        }

        /****************************************************************
         * 5. 완전 소멸된 no_io → BODY / HEADER DELETE
         ****************************************************************/
        const mtlQtioDeletes: any[] = [];
        const mtlQtiohDeletes: any[] = [];

        for (const no_io of targetNoIoSet) {
          const isRemain = qtioSumMapR.has(no_io) || qtioSumMapB.has(no_io);

          if (!isRemain) {
            mtlQtioDeletes.push({
              cd_firm: selectedRows.data.cd_firm,
              no_io,
              fg_slip: 1,
              no_line: 1,
            });

            mtlQtiohDeletes.push({
              cd_firm: selectedRows.data.cd_firm,
              no_io,
            });
          }
        }
        /****************************************************************
         * 6. SaveData 세팅
         ****************************************************************/
        SaveData.mtl_qtioh = {
          insert: [],
          update: [],
          delete: mtlQtiohDeletes,
          modifiedRowcount: mtlQtiohDeletes.length,
        };

        SaveData.mtl_qtio = {
          insert: [],
          update: mtlQtioUpdates,
          delete: mtlQtioDeletes,
          modifiedRowcount: mtlQtioUpdates.length + mtlQtioDeletes.length,
        };

        SaveData.mtl_qtio_tex = {
          insert: [],
          update: [],
          delete: [...mtlQtioTexRowDeletes],
          modifiedRowcount: mtlQtioTexRowDeletes.length,
        };
      }
      const ok = await fnSave("SN_PRD_WRK_REG_001_TEX_SAVE_01", SaveData);
      if (!ok) return false;
      //setFooterDataToRow();
      gridRefs.current["grid1"].current.resetUpdate();
      tabConfig.forEach((tab) => {
        const gridKey = tab.gridKey as keyof typeof gridRefs.current;
        const gridRef = gridRefs.current[gridKey];

        gridRef?.current?.resetUpdate();
      });
      const focusedRow = gridRefs.current["grid1"].current.focusedRowNode();

      if (focusedRow) {
        focusKeyRef.current = {
          no_wo: focusedRow.data.no_wo,
        };
      }
      await onSearch();
      return true;
    } catch (error: any) {
      gridRefs.current["grid1"].current.resetUpdate();
      tabConfig.forEach((tab) => {
        const gridKey = tab.gridKey as keyof typeof gridRefs.current;
        const gridRef = gridRefs.current[gridKey];

        gridRef?.current?.resetUpdate(true);
      });
      return false;
    }
  };

  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event;
    if (selectedRow) {
      const cd_rout = selectedRow.cd_rout;

      const config = ROUT_TAB_CONFIG[cd_rout] ?? ROUT_TAB_CONFIG["T10"];
      setTabConfig(config);
      const firstTab = config[0];

      setTab(firstTab.tabId);
      selectedTabPage.current = firstTab.tabId;

      const allData = allDataRef.current;

      const no_wo = selectedRow.no_wo;
      const newDataSources = {
        grid1: allData.grid1,

        grid2: allData.grid2.filter((row: any) => row.no_wo === no_wo),
        grid3: allData.grid3.filter((row: any) => row.no_wo === no_wo),
        grid6: allData.grid6.filter((row: any) => row.no_wo === no_wo),
        grid7: allData.grid7.filter((row: any) => row.no_wo === no_wo),
        grid4: allData.grid4.filter((row: any) => row.no_wo === no_wo),
        grid5: allData.grid5.filter((row: any) => row.no_wo === no_wo),
      };

      setDataSources(newDataSources);

      setSelectedDocu(no_wo);
    } else {
      return;
    }
  };
  const onAfterSetFooter = () => {
    const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
    const footerData = gridRefs.current["grid5"].current.getFooterData();
    if (focusedNodeH) {
      focusedNodeH.setDataValue("qt_work", footerData.qt);
    }
  };
  const qtCheck = async () => {
    const selectedRows = gridRefs.current["grid1"].current.focusedRowNode();
    if (selectedTabPage.current === "1") {
      const qt_wo = selectedRows.data.qt_wo;
      const qt_divide = selectedRows.data.qt_divide;
      const footerData2 = gridRefs.current["grid2"].current?.getFooterData();
      const qt_w = footerData2?.qt_w;
      const qt_b = footerData2?.qt_b;
      const qt_divide_w = footerData2?.qt_divide_w;
      const qt_divide_b = footerData2?.qt_divide_b;
      //작업지시 수량,절수 편직 수량 절수 체크
      if (
        Number(qt_wo) < Number(qt_w) + Number(qt_b) ||
        Number(qt_divide) < Number(qt_divide_w) + Number(qt_divide_b)
      ) {
        const divideRateRaw =
          Math.trunc(((Number(qt_w) + Number(qt_b) - qt_wo) / qt_wo) * 10000) /
          100;

        const divideRate = isFinite(divideRateRaw) ? divideRateRaw + "%" : "-";
        const divideRateRaw2 =
          Math.trunc(
            ((Number(qt_divide_w) + Number(qt_divide_b) - qt_divide) /
              qt_divide) *
              10000
          ) / 100;

        const divideRate2 = isFinite(divideRateRaw2)
          ? divideRateRaw2 + "%"
          : "-";
        const confirm = await showDialog(
          "confirm",
          "실적량이 초과합니다.\n 실적등록 하시겠습니까?\n\n" +
            "- 이전 지시수량:" +
            qt_wo +
            "\n" +
            "- 실적수량:" +
            (Number(qt_w) + Number(qt_b)) +
            "\n" +
            "- 수량초과율:" +
            divideRate +
            "\n\n" +
            "- 이전 지시절수:" +
            qt_divide +
            "\n" +
            "- 실적절수:" +
            (Number(qt_divide_w) + Number(qt_divide_b)) +
            "\n" +
            "- 절수초과율:" +
            divideRate2
        );
        if (!confirm) return false;
        else return true;
      }
    } else if (selectedTabPage.current === "2") {
      //편직 수량,절수 염색 수량,절수 체크
      const footerData2 = gridRefs.current["grid2"].current?.getFooterData();
      const footerData3 = gridRefs.current["grid3"].current?.getFooterData();
      const qt_w_grid2 = footerData2?.qt_w;
      const qt_divide_w_grid2 = footerData2?.qt_divide_w;
      const qt_w = footerData3?.qt_w;
      const qt_b = footerData3?.qt_b;
      const qt_divide_w = footerData3?.qt_divide_w;
      const qt_divide_b = footerData3?.qt_divide_b;
      if (
        Number(qt_w_grid2) < Number(qt_w) + Number(qt_b) ||
        Number(qt_divide_w_grid2) < Number(qt_divide_w) + Number(qt_divide_b)
      ) {
        const divideRateRaw =
          Math.trunc(
            ((Number(qt_w) + Number(qt_b) - qt_w_grid2) / qt_w_grid2) * 10000
          ) / 100;

        const divideRate = isFinite(divideRateRaw) ? divideRateRaw + "%" : "-";
        const divideRateRaw2 =
          Math.trunc(
            ((Number(qt_divide_w) + Number(qt_divide_b) - qt_divide_w_grid2) /
              qt_divide_w_grid2) *
              10000
          ) / 100;

        const divideRate2 = isFinite(divideRateRaw2)
          ? divideRateRaw2 + "%"
          : "-";
        const confirm = await showDialog(
          "confirm",
          "실적량이 초과합니다.\n 실적등록 하시겠습니까?\n\n" +
            "- 이전 실적수량:" +
            qt_w_grid2 +
            "\n" +
            "- 실적수량:" +
            (Number(qt_w) + Number(qt_b)) +
            "\n" +
            "- 수량초과율:" +
            divideRate +
            "\n\n" +
            "- 이전 실적절수:" +
            qt_divide_w_grid2 +
            "\n" +
            "- 실적절수:" +
            (Number(qt_divide_w) + Number(qt_divide_b)) +
            "\n" +
            "- 절수초과율:" +
            divideRate2
        );
        if (!confirm) return false;
        else return true;
      }
    } else if (selectedTabPage.current === "3") {
      // 워싱 공정 index
      const washingIndex = tabConfig.findIndex((t) => t.tabId === "3");

      // 워싱 footer
      const footerData4 = gridRefs.current["grid6"].current?.getFooterData();

      // 전 공정 footer
      let prevFooterData: any = null;

      if (washingIndex > 0) {
        const prevTab = tabConfig[washingIndex - 1];

        prevFooterData =
          gridRefs.current[prevTab.gridKey]?.current?.getFooterData();
      }

      const qt_w_grid3 = prevFooterData?.qt_w;
      const qt_divide_w_grid3 = prevFooterData?.qt_divide_w;
      const qt_w = footerData4?.qt_w;
      const qt_b = footerData4?.qt_b;
      const qt_divide_w = footerData4?.qt_divide_w;
      const qt_divide_b = footerData4?.qt_divide_b;
      if (
        Number(qt_w_grid3) < Number(qt_w) + Number(qt_b) ||
        Number(qt_divide_w_grid3) < Number(qt_divide_w) + Number(qt_divide_b)
      ) {
        const confirm = await showDialog(
          "confirm",
          "실적량이 초과합니다.\n 실적등록 하시겠습니까?\n\n" +
            "- 이전 실적수량:" +
            qt_w_grid3 +
            "\n" +
            "- 실적수량:" +
            (Number(qt_w) + Number(qt_b)) +
            "\n" +
            "- 수량초과율:" +
            Math.trunc(
              ((Number(qt_w) + Number(qt_b) - qt_w_grid3) / qt_w_grid3) * 10000
            ) /
              100 +
            "%\n\n" +
            "- 이전 실적절수:" +
            qt_divide_w_grid3 +
            "\n" +
            "- 실적절수:" +
            (Number(qt_divide_w) + Number(qt_divide_b)) +
            "\n" +
            "- 절수초과율:" +
            (Number(qt_divide_w_grid3)
              ? Math.trunc(
                  ((Number(qt_divide_w || 0) +
                    Number(qt_divide_b || 0) -
                    Number(qt_divide_w_grid3)) /
                    Number(qt_divide_w_grid3)) *
                    10000
                ) / 100
              : 0) +
            "%"
        );
        if (!confirm) return false;
        else return true;
      }
    } else if (selectedTabPage.current === "4") {
      // 워싱 공정 index
      const washingIndex = tabConfig.findIndex((t) => t.tabId === "4");

      // 워싱 footer
      const footerData4 = gridRefs.current["grid7"].current?.getFooterData();

      // 전 공정 footer
      let prevFooterData: any = null;

      if (washingIndex > 0) {
        const prevTab = tabConfig[washingIndex - 1];

        prevFooterData =
          gridRefs.current[prevTab.gridKey]?.current?.getFooterData();
      }

      const qt_w_grid3 = prevFooterData?.qt_w;
      const qt_divide_w_grid3 = prevFooterData?.qt_divide_w;
      const qt_w = footerData4?.qt_w;
      const qt_b = footerData4?.qt_b;
      const qt_divide_w = footerData4?.qt_divide_w;
      const qt_divide_b = footerData4?.qt_divide_b;
      if (
        Number(qt_w_grid3) < Number(qt_w) + Number(qt_b) ||
        Number(qt_divide_w_grid3) < Number(qt_divide_w) + Number(qt_divide_b)
      ) {
        const confirm = await showDialog(
          "confirm",
          "실적량이 초과합니다.\n 실적등록 하시겠습니까?\n\n" +
            "- 이전 실적수량:" +
            qt_w_grid3 +
            "\n" +
            "- 실적수량:" +
            (Number(qt_w) + Number(qt_b)) +
            "\n" +
            "- 수량초과율:" +
            Math.trunc(
              ((Number(qt_w) + Number(qt_b) - qt_w_grid3) / qt_w_grid3) * 10000
            ) /
              100 +
            "%\n\n" +
            "- 이전 실적절수:" +
            qt_divide_w_grid3 +
            "\n" +
            "- 실적절수:" +
            (Number(qt_divide_w) + Number(qt_divide_b)) +
            "\n" +
            "- 절수초과율:" +
            (Number(qt_divide_w_grid3)
              ? Math.trunc(
                  ((Number(qt_divide_w || 0) +
                    Number(qt_divide_b || 0) -
                    Number(qt_divide_w_grid3)) /
                    Number(qt_divide_w_grid3)) *
                    10000
                ) / 100
              : 0) +
            "%"
        );
        if (!confirm) return false;
        else return true;
      }
    } else if (selectedTabPage.current === "5") {
      // 워싱 공정 index
      const washingIndex = tabConfig.findIndex((t) => t.tabId === "5");

      // 워싱 footer
      const footerData4 = gridRefs.current["grid4"].current?.getFooterData();

      // 전 공정 footer
      let prevFooterData: any = null;

      if (washingIndex > 0) {
        const prevTab = tabConfig[washingIndex - 1];

        prevFooterData =
          gridRefs.current[prevTab.gridKey]?.current?.getFooterData();
      }

      const qt_w_grid3 = prevFooterData?.qt_w;
      const qt_divide_w_grid3 = prevFooterData?.qt_divide_w;
      const qt_w = footerData4?.qt_w;
      const qt_b = footerData4?.qt_b;
      const qt_divide_w = footerData4?.qt_divide_w;
      const qt_divide_b = footerData4?.qt_divide_b;
      if (
        Number(qt_w_grid3) < Number(qt_w) + Number(qt_b) ||
        Number(qt_divide_w_grid3) < Number(qt_divide_w) + Number(qt_divide_b)
      ) {
        const confirm = await showDialog(
          "confirm",
          "실적량이 초과합니다.\n 실적등록 하시겠습니까?\n\n" +
            "- 이전 실적수량:" +
            qt_w_grid3 +
            "\n" +
            "- 실적수량:" +
            (Number(qt_w) + Number(qt_b)) +
            "\n" +
            "- 수량초과율:" +
            Math.trunc(
              ((Number(qt_w) + Number(qt_b) - qt_w_grid3) / qt_w_grid3) * 10000
            ) /
              100 +
            "%\n\n" +
            "- 이전 실적절수:" +
            qt_divide_w_grid3 +
            "\n" +
            "- 실적절수:" +
            (Number(qt_divide_w) + Number(qt_divide_b)) +
            "\n" +
            "- 절수초과율:" +
            (Number(qt_divide_w_grid3)
              ? Math.trunc(
                  ((Number(qt_divide_w || 0) +
                    Number(qt_divide_b || 0) -
                    Number(qt_divide_w_grid3)) /
                    Number(qt_divide_w_grid3)) *
                    10000
                ) / 100
              : 0) +
            "%"
        );
        if (!confirm) return false;
        else return true;
      }
    } else if (selectedTabPage.current === "6") {
      //워싱 수량,절수 검사 수량,절수 체크
      const footerData4 = gridRefs.current["grid4"].current?.getFooterData();
      const footerData5 = gridRefs.current["grid5"].current?.getFooterData();
      const qt_w_grid4 = footerData4?.qt_w;
      const qt_divide_w_grid4 = footerData4?.qt_divide_w;
      const qt_w = footerData5?.qt_w;
      const qt_b = footerData5?.qt_b;
      const qt_divide_w = footerData5?.qt_divide_w;
      const qt_divide_b = footerData5?.qt_divide_b;
      if (
        Number(qt_w_grid4) / selectedRows.data.qt_dummy01 <
          Number(qt_w) + Number(qt_b) ||
        Number(qt_divide_w_grid4) < Number(qt_divide_w) + Number(qt_divide_b)
      ) {
        const confirm = await showDialog(
          "confirm",
          "실적량이 초과합니다.\n 실적등록 하시겠습니까?\n\n" +
            "- 이전 실적수량:" +
            qt_w_grid4 +
            "(" +
            Math.trunc(qt_w_grid4 / selectedRows.data.qt_dummy01) +
            ")\n" +
            "- 실적수량:" +
            (Number(qt_w) + Number(qt_b)) +
            "\n" +
            "- 수량초과율:" +
            Math.trunc(
              ((Number(qt_w) +
                Number(qt_b) -
                Math.trunc(qt_w_grid4 / selectedRows.data.qt_dummy01)) /
                Math.trunc(qt_w_grid4 / selectedRows.data.qt_dummy01)) *
                10000
            ) /
              100 +
            "%\n\n" +
            "- 이전 실적절수:" +
            qt_divide_w_grid4 +
            "\n" +
            "- 실적절수:" +
            (Number(qt_divide_w) + Number(qt_divide_b)) +
            "\n" +
            "- 절수초과율:" +
            (Number(qt_divide_w_grid4)
              ? Math.trunc(
                  ((Number(qt_divide_w || 0) +
                    Number(qt_divide_b || 0) -
                    Number(qt_divide_w_grid4)) /
                    Number(qt_divide_w_grid4)) *
                    10000
                ) / 100
              : 0) +
            "%"
        );
        if (!confirm) return false;
        else return true;
      }
    }
    return true;
  };
  const onRowDataReady = () => {
    const focusKey = focusKeyRef.current;
    if (!focusKey) return;

    const grid = gridRefs.current["grid1"].current;

    const rowCount = grid.getDisplayedRowCount();
    let targetIndex = -1;

    for (let i = 0; i < rowCount; i++) {
      const rowNode = grid.getRowNodeAtIndex(i);
      if (!rowNode?.data) continue;

      if (rowNode.data.no_wo === focusKey.no_wo) {
        targetIndex = i;
        break;
      }
    }

    if (targetIndex >= 0) {
      grid.selectAndFocusRow(targetIndex);
      grid.scrollToIndex?.(targetIndex);
    } else {
      grid.selectAndFocusRow(0);
    }

    focusKeyRef.current = null;
  };
  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged: onFocusedRowChanged,
          onRowDataReady: onRowDataReady,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onCellValueChanged: onCellValueChangedL,
        },
      },
      grid3: {
        columns: columns.grid3,
        dataSource: dataSources.grid3,
        events: {
          onCellValueChanged: onCellValueChangedL,
        },
      },

      grid6: {
        columns: columns.grid6,
        dataSource: dataSources.grid6,
        events: {
          onCellValueChanged: onCellValueChangedL,
        },
      },
      grid7: {
        columns: columns.grid7,
        dataSource: dataSources.grid7,
        events: {
          onCellValueChanged: onCellValueChangedL,
        },
      },
      grid4: {
        columns: columns.grid4,
        dataSource: dataSources.grid4,
        events: {
          onCellValueChanged: onCellValueChangedL,
        },
      },
      grid5: {
        columns: columns.grid5,
        dataSource: dataSources.grid5,
        events: {
          onCellValueChanged: onCellValueChangedL,
          onAfterSetFooter: onAfterSetFooter,
        },
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        />
      </div>

      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizeBar direction={"height"} id="panel1" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{ rowSelection: "single", title: "작업지시" }}
            events={grids.grid1.events}
          />
        </SnResizeBar>
        <SnResizeBar direction={"height"} id="panel2" orgSize="45.5%">
          <SnTab
            key={selectedDocu}
            titles={tabConfig.map((v) => v.title)}
            width={"100%"}
            //selectedTab={onTabChanged}
            onTabChanged={async (index: any) => {
              const tab = tabConfig[index - 1];
              if (!tab) return;

              const currentTab = tabConfig.find(
                (v) => v.tabId === selectedTabPage.current
              );

              if (currentTab) {
                const grid = gridRefs.current[currentTab.gridKey]?.current;

                if (grid) {
                  const change = grid.getChange();

                  if (change.modifiedRowcount > 0) {
                    const confirmMove = await showDialog(
                      "confirm",
                      "수정된 내용이 있습니다. 저장하시겠습니까?"
                    );

                    if (!confirmMove) return;
                    onSave();
                  }
                }
              }
              setTab(tab.tabId);
              selectedTabPage.current = tab.tabId;
            }}
            body={tabConfig.map((v) => {
              const gridKey = v.gridKey as keyof typeof grids;

              return (
                <SnGrid
                  key={gridKey}
                  ref={gridRefs.current[gridKey]}
                  columnConfig={grids[gridKey].columns}
                  rowData={grids[gridKey].dataSource}
                  etcProps={{ rowSelection: "single" }}
                  events={grids[gridKey].events}
                />
              );
            })}
          />
        </SnResizeBar>
        <SnFileUploadBox
          selectedDocu={selectedDocu}
          selectedLineDocu={selectedLineDocu}
        />
      </div>
    </div>
  );
  //#endregion
});

export default SN_PRD_WRK_REG_001_TEX;
